// src/constants/routes.ts
export const ROUTES = {
  // Dashboard/List views
  HOME: '/',
  CUSTOMERS: '/customers',
  DASHBOARD: '/dashboard',
  TVDASHBOARD: '/tv-dashboard',
  REPORT: '/report',
  STATE_ACTIVITIES: '/state-activities',
  TECHNICIAN_ORDERS: '/report/technician/:technicianId/orders',
  // Default list = the server-paginated v2 (mold-order-list-v2 plan). The old client-side list
  // is kept as a backup at MOLD_ORDERS_V1. MOLD_ORDERS_V1 must be registered in App.tsx BEFORE
  // MOLD_ORDER_DETAIL's `/mold-orders/:id` so "v1" is never captured as an order id.
  MOLD_ORDERS: '/mold-orders',
  MOLD_ORDERS_V1: '/mold-orders/v1',
  MOLD_ORDER_DETAIL: '/mold-orders/:id',
  NOTIFICATIONS: '/notifications',
  MY_WORKS: '/my-works',
  SORT_MOLD_ORDERS: '/sort-mold-orders/:id',
  QUESTIONNAIRE: '/questionnaires/:id',
  CREATE_MOLD_ORDERS: '/mold-orders/create',
  CREATE_MOLD_ORDERS_MENU: '/mold-orders/create-menu',
  CREATE_REPAIR_ORDERS: '/mold-orders/create?type=repair',
  CREATE_MODIFY_ORDERS: '/mold-orders/create?type=modify',
  CREATE_MAINTENANCE_ORDERS: '/mold-orders/create?type=maintenance',
  CREATE_MOLD_ACCEPTANCE_ORDERS: '/mold-orders/create?type=mold_acceptance',
  CREATE_MOLD_EXPORT_ORDERS: '/mold-orders/create?type=mold_export',
  CREATE_NEW_MOLD: '/mold/create',
  SCAN_MOLD: '/scan',

  // Batch operations
  // CREATE_BATCH_CLEANING_ORDERS: '/cleaning-orders/batch/create',

  // Related routes
  MOLDS: '/molds',
  MOLD_DETAILS: '/molds/:id',
  USERS: '/users',
  MY_PROFILE: '/profile',
  PRODUCT_PARTS: '/product-parts',
  INSERTS: '/inserts',
  CONFIGURATION: '/configuration',
  SHOTCOUNT_LOG: '/shotcount-log',
  FORM_JSON_EDITOR: '/form-json-editor',
  ORDER_EXPORT: '/order-export',
  MOLD_ORDER_TYPE_EXPLORER: '/mold-order-type-explorer',
  WORKFLOWS: '/workflows',
  SYSTEM_STATUS: '/system-status',
} as const;
